
import React from 'react';
import { useCollegeDetQuery } from '../../store/api/userApiSlice';
import { IoArrowForward } from 'react-icons/io5';
import './FeaturedColleges.css';
import collegePlaceholder from '../../assets/images/ftrdClgImgPlaceholder.png';
import locationIcon from '../../assets/icons/location.png';

const FeaturedColleges = () => {
    // Determine number of skeleton items based on screen width
    // This logic ensures responsive skeleton loading
    // For small screens (<768px): 1 item
    // For medium screens (768px-1024px): 2 items
    // For large screens (>1024px): 3 items
    const getSkeletonCount = () => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 768) return 1;
            if (window.innerWidth < 1024) return 2;
            return 3;
        }
        return 3;
    };

    const { data, isLoading, error } = useCollegeDetQuery();
    // API returns { institute: [...] } or array or { data: [...] }
    const colleges = data?.data || data?.colleges || data?.institute || (Array.isArray(data) ? data : []) || [];

    if (isLoading) {
        return (
            <div className="featured-colleges-wrapper">
                <section className="featured-colleges-section">
                    <h2 className="featured-heading">Featured Colleges</h2>
                    <div className="featured-grid">
                        {[...Array(getSkeletonCount())].map((_, index) => (
                            <div key={index} className="college-card skeleton-card">
                                <div className="skeleton-image"></div>
                                <div className="college-details">
                                    <div className="skeleton-tag"></div>
                                    <div className="skeleton-title"></div>
                                    <div className="skeleton-footer"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        );
    }

    if (error) {
         // Silently fail or show minimal error state, preferably just return null or empty wrapper 
         // so as not to break the page flow if one section fails.
         return (
            <div className="featured-colleges-wrapper">
                <section className="featured-colleges-section">
                    <h2 className="featured-heading">Featured Colleges</h2>
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <p>Unable to load featured colleges.</p>
                    </div>
                </section>
            </div>
         );
    }

    return (
        <div className="featured-colleges-wrapper">
            <section className="featured-colleges-section">
                <h2 className="featured-heading">Featured Colleges</h2>
                
                <div className="featured-grid">
                    {colleges.slice(0, 4).map((college) => (
                        <div key={college._id} className="college-card">
                            <div className="college-image-container">
                                <img src={collegePlaceholder} alt={college.name} className="college-image" />
                            </div>
                            
                            <div className="college-details">
                                <div className="college-tag">
                                    {/* Placeholder data since API lacks these fields */}
                                    Engineering | NIRF Rank N/A
                                </div>
                                <h3 className="college-name">{college.name}</h3>
                                
                                <div className="college-card-footer">
                                    <div className="college-location">
                                        <img src={locationIcon} alt="Location" className="location-icon" />
                                        <span>{college.town || college.city || college.district || "City"}, {college.state}</span>
                                    </div>
                                    
                                    <a 
                                        href="#" 
                                        onClick={(e) => e.preventDefault()}
                                        className="learn-more-link"
                                    >
                                        Know more <IoArrowForward />
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default FeaturedColleges;
